import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-menu-jl-parent",
  "use": "icon-menu-jl-parent-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-menu-jl-parent\"><path d=\"M320.062 575.468v448.384l704.137-0.682-0.866-449.039-703.271 1.337z m640.124 383.533l-576.112 0.807V639.59l576.112-0.682v320.093zM315.905 383.648l-251.533-0.19V64.74l251.533 0.235V0.618H0.36v446.884l315.545 0.249z\" p-id=\"51598\" /><path d=\"M256.065 193.144h447.221v63.919H256.065z\" p-id=\"51599\" /><path d=\"M448.102 0.389h63.092v447.124h-63.092zM192.296 779.618l0.001-46.81V444.223l-0.26-51.398-64.012-1.044-0.741 440.168 196.41-0.228v-63.919l-132.398 0.131z\" p-id=\"51600\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svgIcons/menu-jl-parent.svg
// module id = 1238
// module chunks = 20